import { Admins } from "../AdminSettings/dataTypes";
import { ButtonInterface } from "apps/company/common/dataTypes";

export interface CompanyPortalIntegrationsScreen {
  title: string;
  subTitle: string;
  domains: Domains;
  companyInfo: CompanyInfo;
  sso: CompanySSO;
  hris: HRIS;
  companyAdmins: Admins;
}

export interface Domains {
  title: string;
  addButton: ButtonInterface;
  subTitle: string;
  labels: string[];
  domainList: DomainList[];
}

export interface DomainList {
  name: string;
  dateAdded: string;
  action: ButtonInterface;
}
export interface CompanyInfo {
  title: string;
  subTitle: string;
  photoUrl?: string;
  companyName: string;
  billingEmail: string;
  address?: string;
}

export interface CompanySSO {
  title: string;
  subTitle: string;
  signIn: SignInOptions;
  signUp: SignUpOptions;
}

export interface SignInOptions {
  title: string;
  items: SSOItem[];
}

export interface SignUpOptions {
  title: string;
  isEnabled: boolean;
}

export interface SSOItem {
  id: string;
  name: string;
  isEnabled: boolean;
}

export interface Connection {
  id: string;
  logo: string;
  name: string;
  subCompanyName: string;
}

export interface HRIS {
  title: string;
  subTitle: string;
  connections: Connection[];
  link: string;
}

export enum SIGN_IN_TOGGLE {
  OKTA = "okta",
  GOOGLE = "google-oauth2",
  MAGIC_LINK = "magic-link",
  MICROSOFT = "azuread-oauth2",
  PASSWORD = "email-and-pwd",
  SELF_SIGNUP = "self-signup",
}
